<div *ngIf="!isMainPageButton; else isMainPage" class="favoritesButton">
  <button #openFavoritesButton class="favoritesButton" mat-stroked-button data-test="favorites-button" (click)="handleClick()">
    <mat-icon>search</mat-icon>
    <span>{{ 'app.favorites.title' | translate }}</span>
    <mat-icon iconPositionEnd>star</mat-icon>
  </button>
</div>

<ng-template #isMainPage>
  <button #openFavoritesButtonInTemplate class="mainPageFavoritesButton" mat-stroked-button data-test="favorites-button" (click)="handleClick()">
    <mat-icon color="accent">star</mat-icon>
    <span class="mainPageFavoritesButton-title">{{ 'app.favorites.title' | translate }}</span>
  </button>
</ng-template>
